import { render, staticRenderFns } from "./VuetablePaginationInfo.vue?vue&type=template&id=21582470&"
import script from "./VuetablePaginationInfo.vue?vue&type=script&lang=js&"
export * from "./VuetablePaginationInfo.vue?vue&type=script&lang=js&"
import style0 from "./VuetablePaginationInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports